/**
 * @generated SignedSource<<be38b7c3e249c7bc37436e3ceb8f63f8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileMatchBottomSheet_fromProfile$data = {
  readonly name: string;
  readonly rowId: any;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatar_profile">;
  readonly " $fragmentType": "ProfileMatchBottomSheet_fromProfile";
};
export type ProfileMatchBottomSheet_fromProfile$key = {
  readonly " $data"?: ProfileMatchBottomSheet_fromProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileMatchBottomSheet_fromProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileMatchBottomSheet_fromProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileAvatar_profile"
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "114932e50a44ba06ce1dfe5d34f91978";

export default node;
